export const bemPrefix = 'SearchResultCard';
